// extracted by mini-css-extract-plugin
export default {"text":"percentageText_text__jOgeR","symbol":"percentageText_symbol__pGfRd"};